import loadable from '@loadable/component'
import * as React from 'react'
import { Switch } from 'react-router'

import TripGuard from './components/TripGuard/TripGuard'
import RootWrapper from './pages/RootWrapper'
import Trip404Page from './pages/Trip404Page'
import type { TripTab } from './utils/tabs'
import TripTabRedirect from './pages/TripTabRedirect'

import AuthRoute from 'components/App/Routes/AuthRoute'
import Route from 'components/App/Routes/TrackedRoute'
import WebViewRoutes from 'tripPlanner/pages/WebViews/WebViewRoutes'

const TripPlannerLandingPage = loadable(
  () =>
    import(
      /* webpackChunkName: "TripPlannerLandingPage" */ 'tripPlanner/pages/trip/TripPlannerLandingPage'
    ),
)

const PublicTripParent = loadable(
  () =>
    import(
      /* webpackChunkName: "TripPlannerPublicTripParent" */ 'tripPlanner/pages/publicTrip/PublicTripParent'
    ),
)

const TripPlannerAboutPage = loadable(
  () =>
    import(
      /* webpackChunkName: "TripPlannerAboutPage" */ 'tripPlanner/pages/about/TripPlannerAboutPage'
    ),
)

const GenerateTripPage = loadable(
  () =>
    import(
      /* webpackChunkName: "GenerateTripPage" */ 'tripPlanner/pages/trip/GenerateTripPage'
    ),
)

const ChatTripPlannerPage = loadable(
  () =>
    import(
      /* webpackChunkName: "ChatTripPlannerPage" */ 'tripPlanner/pages/chat/ChatTripPlannerPage'
    ),
)

const TripParent = loadable(
  () =>
    import(
      /* webpackChunkName: "TripPlannerTripParent" */ 'tripPlanner/pages/trip/TripParent'
    ),
)

const AcceptInvite = loadable(
  () =>
    import(
      /* webpackChunkName: "TripPlannerAcceptInvite" */ './pages/trip/AcceptInvite'
    ),
)

const CreateFromOrder = loadable(
  () =>
    import(
      /* webpackChunkName: "TripPlannerCreateFromOrder" */
      './pages/trip/CreateFromOrder'
    ),
)

const HiddenSettings = loadable(
  () =>
    import(
      /* webpackChunkName: "HiddenSettings" */
      './pages/hiddenSettings/HiddenSettings'
    ),
)

const tabs: Array<Lowercase<TripTab>> = ['summary', 'itinerary', 'explore', 'documents']
function TripPlannerRoutes() {
  return (
    <TripGuard fallback={<Trip404Page />}>
      <RootWrapper>
        <Switch>
          <Route
            exact
            path="/:regionCode/trip-planner/about"
            component={TripPlannerAboutPage}
          />
          <Route
            exact
            path="/:regionCode/trip-planner"
            component={TripPlannerLandingPage}
          />
          <Route
            exact
            path="/:regionCode/trip-planner/generate-trip"
            component={GenerateTripPage}
          />
          <Route
            exact
            path="/:regionCode/trip-planner/chat-trip-planner/:chatId?"
            component={ChatTripPlannerPage}
          />
          <AuthRoute
            showPopup
            exact
            path={`/:regionCode/trip-planner/trip/:tripId/:tab(${tabs.join('|')})`}
            component={TripParent}
          />
          <Route
            exact
            path="/:regionCode/trip-planner/public-trip/:tripId/:tab(summary|itinerary)"
            component={PublicTripParent}
          />
          <AuthRoute
            showPopup
            exact
            path="/:regionCode/trip-planner/trip/:tripId/accept-invite/:inviteId"
            component={AcceptInvite}
          />
          <AuthRoute
            showPopup
            exact
            path="/:regionCode/trip-planner/create"
            component={CreateFromOrder}
          />
          <AuthRoute
            showPopup
            exact
            path="/:regionCode/trip-planner/hidden-settings"
            component={HiddenSettings}
          />
          <Route path="/:regionCode/trip-planner/webView">
            <WebViewRoutes />
          </Route>
          <Route
            exact
            path="/:regionCode/trip-planner/trip/:tripId"
            component={TripTabRedirect}
          />
          <Trip404Page />
        </Switch>
      </RootWrapper>
    </TripGuard>
  )
}

export default TripPlannerRoutes
